/* @flow */

const createNetworkError = (message: string = 'Network Error') => {
  const err: Object = new Error(message);
  err.type = 'NetworkError';
  err.modalIllustration = 'warning';
  return err;
};

const isNetworkError = (x: any) => {
  return x instanceof Error && x.type === 'NetworkError';
};

export {
  createNetworkError,
  isNetworkError
};
